import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Import from "../../../../assets/images/ic-Import.svg";
import ImportUser from "../../../../assets/images/imagesuser.png";
import ApiConfig from "../../../../api/ApiConfig";
import { simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

const UserAppsVersionReport = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [platform, setPlatform] = useState("");
  const [appType, setAppType] = useState("");
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);
  const [pageid, setPageid] = useState("1");

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    fetchReport();
  }, [platform, appType, OptionDownload]);

  const fetchReport = () => {
    const body = {
      format: OptionDownload,
      user_app_type: appType,
      user_id: "",
      user_os: platform,
      pageid: pageid,
      language: localStorage.getItem("language") || "en",
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(
      ApiConfig.USER_APPS_VERSION_REPORT,
      JSON.stringify(body)
    )
      .then((res) => {
        if (res?.result) setOrderListData(res?.userapp || []);
        else setOrderListData([]);
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>{t("User Apps Version Report")}</p>
                </p>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "150px" }}
                  className="custom-select"
                  placeholder={t("Platform")}
                  value={platform}
                  onChange={(value) => setPlatform(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("All Platform")}
                  </Option>
                  <Option value="android" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Android")}
                  </Option>
                  <Option value="ios" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("iOS")}
                  </Option>
                  <Option value="web" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Web")}
                  </Option>
                </Select>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("App Type")}
                  value={appType}
                  onChange={(value) => setAppType(value)}
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("All Apps")}
                  </Option>
                  <Option value="1" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Driver App")}
                  </Option>
                  <Option value="3" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Fleet Manager App")}
                  </Option>
                  <Option value="4" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Delivery Person App")}
                  </Option>
                </Select>
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* === GREEN :: API INTEGRATED (columns mapped to reference UI) === */}
            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("Image")}</th>
                  <th>{t("Name")}</th>
                  <th>{t("User App Type")}</th>
                  <th>{t("Device Os")}</th>
                  <th>{t("Device Id")}</th>
                  <th>{t("Installed Version")}</th>
                  <th>{t("Available Version")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {OrderListData && OrderListData?.length > 0
                    ? OrderListData.map((item, index) => (
                        <tr className="text-center" key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <img
                              src={
                                item.user_profile_pic
                                  ? item.user_profile_pic
                                  : ImportUser
                              }
                              alt=""
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          </td>
                          <td>
                            {item.user_name} {item.user_last_name}
                          </td>
                          <td>{item.user_apps_type}</td>
                          <td>{item.user_apps_device_os}</td>
                          <td>{item.user_apps_device_id}</td>
                          <td>{item.user_apps_version}</td>
                          <td>
                            {item.available_version
                              ? item.available_version
                              : "--"}
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default UserAppsVersionReport;
